// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-grid-list__item--extended .czt-grid-list__item__content,.czt-grid-list__item--extended .czt-grid-list__item__content p{color:#fff;text-shadow:0 0 6px rgba(0,0,0,.8)}.czt-grid-list__item--extended .czt-headline{text-shadow:0 0 10px rgba(0,0,0,.8) !important}", ""]);
// Exports
module.exports = exports;
